var _excluded = ["theme"];

function cov_xneq8aal3() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/ODThemeLite.tsx";
  var hash = "fb271082db10a643db6b47188274bb7c66f09bc2";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/ODThemeLite.tsx",
    statementMap: {
      "0": {
        start: {
          line: 14,
          column: 5
        },
        end: {
          line: 14,
          column: 87
        }
      },
      "1": {
        start: {
          line: 14,
          column: 30
        },
        end: {
          line: 14,
          column: 87
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 14,
            column: 5
          },
          end: {
            line: 14,
            column: 6
          }
        },
        loc: {
          start: {
            line: 14,
            column: 30
          },
          end: {
            line: 14,
            column: 87
          }
        },
        line: 14
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 14,
            column: 63
          },
          end: {
            line: 14,
            column: 83
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 14,
            column: 71
          },
          end: {
            line: 14,
            column: 76
          }
        }, {
          start: {
            line: 14,
            column: 79
          },
          end: {
            line: 14,
            column: 83
          }
        }],
        line: 14
      }
    },
    s: {
      "0": 0,
      "1": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "fb271082db10a643db6b47188274bb7c66f09bc2"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_xneq8aal3 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_xneq8aal3();

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { ThemeProvider } from '@chakra-ui/system';
import { eero } from '../theme'; // Provide a theme without the heavy spritesheet (saves around 20kb gzipped)
// this "Lite" theme may include further optimizations in the future

cov_xneq8aal3().s[0]++;
export var ThemedLite = function ThemedLite(_ref) {
  var theme = _ref.theme,
      props = _objectWithoutProperties(_ref, _excluded);

  cov_xneq8aal3().f[0]++;
  cov_xneq8aal3().s[1]++;
  return /*#__PURE__*/React.createElement(ThemeProvider, _extends({}, props, {
    theme: theme ? (cov_xneq8aal3().b[0][0]++, theme) : (cov_xneq8aal3().b[0][1]++, eero)
  }));
};